import React from 'react';
import './App.css';
import {VersionsEditor} from './Components';

function App() {
  return (
    <div className='App'>
      <main className='App-main'>
          <VersionsEditor />
      </main>
    </div>
  );
}

export default App;
